export default __webpack_public_path__ + "static/media/bg.5739e449.png";